var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.105469,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E7F7EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 17.659C13.7812 18.519 14.4413 19.2124 15.2613 19.2124H16.9346C17.6479 19.2124 18.2279 18.6057 18.2279 17.859C18.2279 17.0457 17.8746 16.759 17.3479 16.5724L14.6612 15.639C14.1346 15.4524 13.7812 15.1657 13.7812 14.3524C13.7812 13.6057 14.3612 12.999 15.0746 12.999H16.7479C17.5679 12.999 18.2279 13.6924 18.2279 14.5524",
    stroke: "#0CAF60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.1055V20.1055",
    stroke: "#0CAF60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 22.7718C19.6825 22.7718 22.6673 19.787 22.6673 16.1051C22.6673 12.4232 19.6825 9.43848 16.0007 9.43848C12.3188 9.43848 9.33398 12.4232 9.33398 16.1051C9.33398 19.787 12.3188 22.7718 16.0007 22.7718Z",
    stroke: "#0CAF60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.c1e694ce5ae050a6581041edea8ef588.svg";
export { ForwardRef as ReactComponent };